module.exports = __webpack_public_path__ + "static/media/pre_wedding_fun.b4547fbb.svg";